import { useEffect, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';

import { Sidebar } from './Sidebar';
import logoMark from '@/images/resdelivery.png';

export function Layout({ children }: { children: ReactNode }) {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!navOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [navOpen]);

  return (
    <div className="h-full flex flex-col lg:flex-row">
      <header className="lg:hidden flex items-center gap-3 px-3 h-14 bg-white border-b border-line sticky top-0 z-30">
        <button
          onClick={() => setNavOpen(true)}
          className="p-2 -ml-2 rounded-lg hover:bg-paper text-ink/70"
          aria-label="Открыть меню"
        >
          <Menu size={20} />
        </button>
        <div className="flex items-center gap-2 min-w-0">
          <img src={logoMark} alt="Resstro" className="w-7 h-7 rounded-md object-cover shrink-0" />
          <div className="leading-tight min-w-0">
            <div className="font-semibold text-sm truncate text-ink">Resstro</div>
            <div className="text-[10px] text-ink/40">кабинет поставщика</div>
          </div>
        </div>
      </header>

      <div
        className={[
          'fixed inset-y-0 left-0 z-50 w-[82%] max-w-xs bg-white shadow-xl transform transition-transform duration-200',
          'lg:static lg:translate-x-0 lg:w-64 lg:shadow-none lg:max-w-none',
          navOpen ? 'translate-x-0' : '-translate-x-full',
        ].join(' ')}
      >
        <Sidebar onNavigate={() => setNavOpen(false)} />
      </div>

      {navOpen && (
        <button
          type="button"
          aria-label="Закрыть меню"
          onClick={() => setNavOpen(false)}
          className="fixed inset-0 z-40 bg-ink/50 lg:hidden"
        />
      )}

      <main className="flex-1 overflow-auto bg-paper min-w-0">
        <div className="px-4 py-4 sm:px-6 sm:py-6 max-w-5xl mx-auto">{children}</div>
      </main>
    </div>
  );
}
